import React, { Component, createContext } from 'react';
import PropTypes from 'prop-types';

export const CoreInterfaceContext = createContext();

let coreInterfaceVal = {
  triggerGlobalEvent: () => {
    // required empty function due to calls from One-PTX
  },
  unauthenticated: () => {
    // required empty function due to calls from One-PTX
  },
  unauthorised: () => {
    // required empty function due to calls from One-PTX
  },
  forbidden: () => {
    // required empty function due to calls from One-PTX
  },
  onError: () => {
    // required empty function due to calls from One-PTX
  },
  notFound: () => {
    // required empty function due to calls from One-PTX
  },
  serverError: () => {
    // required empty function due to calls from One-PTX
  },
  unavailable: () => {
    // required empty function due to calls from One-PTX
  },
  updateToken: () => Promise.resolve()
};

export class CoreInterfaceProvider extends Component {
  constructor(props) {
    super(props);
    this.state = { coreInterface: props.coreInterface };
  }

  render() {
    const { coreInterface } = this.state;
    const { children } = this.props;
    return (
      <CoreInterfaceContext.Provider value={coreInterface}>
        {children}
      </CoreInterfaceContext.Provider>
    );
  }
}

export function withCoreInterface(ReactComponent) {
  return function WrapperComponent(props) {
    return (
      <CoreInterfaceContext.Consumer>
        {state => <ReactComponent {...props} coreInterface={state} />}
      </CoreInterfaceContext.Consumer>
    );
  };
}

CoreInterfaceProvider.defaultProps = {
  /** Additional content to be displayed on the far right inline with the heading. */
  children: PropTypes.node,
};
CoreInterfaceProvider.propTypes = {
  /** Additional content to be displayed on the far right inline with the heading. */
  children: PropTypes.node,
  coreInterface: PropTypes.objectOf(PropTypes.any).isRequired,
};

export const getCoreInterface = () => coreInterfaceVal;
export const setCoreInterface = data => {
  coreInterfaceVal = Object.assign(coreInterfaceVal, data);
};
